import lodash from 'lodash'

import { TOrderEntryFormValues } from '../types'

function mergeProp(o1: any, o2: any, property: string): any {
  // console.log('mergeProp', { o1, o2, property })
  return lodash.merge(lodash.get(o1, property), lodash.get(o2, property))
}

function either(o1: any, o2: any, property: string): any {
  const p1 = lodash.get(o1, property)
  const p2 = lodash.get(o2, property)
  // TODO: proper check for arrays, objects, and numbers/strings
  // p2 === -1 is an exception for slaTypeId
  const result = !lodash.isEmpty(p2) || p2 === -1 ? p2 : p1
  return result
}

export default function mergeAdditionalValues(
  o1: TOrderEntryFormValues,
  o2: TOrderEntryFormValues,
): TOrderEntryFormValues {
  // console.log('mergeAdditionalValues', { o1, o2 })
  const result = {
    ...o1,
    ...o2,
    pickup: mergeProp(o1, o2, 'pickup'),
    delivery: mergeProp(o1, o2, 'delivery'),
    invoice: mergeProp(o1, o2, 'invoice'),
    neutralSender: mergeProp(o1, o2, 'neutralSender'),
    colis: either(o1, o2, 'colis'),
    defaultSla: either(o1, o2, 'defaultSla'),
    defaultSlaTypeId: either(o1, o2, 'defaultSlaTypeId'),
    defaultSlaTypeName: either(o1, o2, 'defaultSlaTypeName'),
  }
  // console.log('result', result)
  return result
}
